<template>
    <div class="animated fadeIn staticPageInner bgV2 pb-19">
        <b-row class="heig-frame-tab">
            <b-col md="12" class="pt-20">
                <div class="p-3 bg-white boxShadow box-shadow-none mt--1 no-boder">
                    <div class="boxShadow noBorder mb-0">
                        <div class="padding-13 pt-4 heig-frame-child">
                            <form autocomplete="off" style="width: 200px;margin: 0 auto">
                                <gofix-form-input-time desc="hh:mm" v-model="time" required></gofix-form-input-time>

                                <gofix-form-input-textarea v-model="textarea"></gofix-form-input-textarea>

                                <gofix-form-input-date
                                        desc="dd.mm.yyyy"
                                        v-model="date.value"
                                        required
                                        label="Input date">
                                </gofix-form-input-date>

                                <gofix-form-input-number label="Phone" v-model="input.number" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false"></gofix-form-input-number>
                                <gofix-form-input label="Input Text Input Text Input Text Input Text Input Text Input Text Input Text Input Text Input Text" v-model="input.text" autocomplete="off"></gofix-form-input>
                                <gofix-form-input label="Input Email" type="email" v-model="input.email" autocomplete="off"></gofix-form-input>
                                <gofix-form-input-number label="Input Money" v-model="input.money" prefix="$" required></gofix-form-input-number>
                                <gofix-form-input-number label="Input Float" :include-thousands-separator="false" v-model="input.float" allowNegative required></gofix-form-input-number>
                                <gofix-form-input-number label="Input Number" v-model="input.number" :allowDecimal="false" allowNegative required></gofix-form-input-number>







                                <gofix-form-properties

                                    label="Select Property"
                                    :contract-id="311"
                                    showIconRequired
                                    v-model="property.value" required>
                                </gofix-form-properties>


                     <!--           <gofix-form-supplier
                                    label="Select supplier"
                                    :contract-id="311"
                                    :required="true"
                                    v-model="supplier">
                                </gofix-form-supplier>-->

                                <gofix-form-tree
                                        label="Tree multiple"
                                        :multiple="true"
                                        :options="tree.options"
                                        v-model="tree.multiple" required>
                                </gofix-form-tree>

                                <gofix-form-tree
                                        :options="tree.options"
                                        v-model="tree.value" required>
                                </gofix-form-tree>

                                <gofix-form-dropdown
                                        :filterable="false"
                                        :required="true"
                                        v-model="dropdown.value"
                                        :options="dropdown.options">
                                </gofix-form-dropdown>

                                <gofix-form-dropdown
                                        label="Test"
                                        :filterable="false"
                                        :required="true"
                                        :multiple="true"
                                        v-model="dropdown.value2"
                                        :options="dropdown.options">
                                </gofix-form-dropdown>


                            </form>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    export default {
        name: 'form-inputs',
        components: {

        },
        data() {
            return {
                time:"08:35",
                textarea:null,
                date:{
                    value:null
                },
                input:{
                  text:null,
                  email:null,
                  password:null,
                  money: null,
                  float: null,
                  number:null,
                },
                supplier: null,
                tree: {
                    value : null,
                    multiple : null,
                    options: [{
                        id: 'folder',
                        label: 'Normal Folder',
                        children: [{
                            id: 'disabled-checked',
                            label: 'Checked',
                        }, {
                            id: 'disabled-unchecked',
                            label: 'Unchecked',
                        }, {
                            id: 'item-1',
                            label: 'Item',
                        }],
                    }, {
                        id: 'disabled-folder',
                        label: 'Disabled Folder',
                        children: [{
                            id: 'item-2',
                            label: 'Item',
                            children: [{
                                id: 'item-21',
                                label: 'Item',
                            }, {
                                id: 'item-22',
                                label: 'Item',
                            }],
                        }, {
                            id: 'item-3',
                            label: 'Item',
                            children: [{
                                id: 'item-31',
                                label: 'Item',
                            }, {
                                id: 'item-32',
                                label: 'Item',
                            }],
                        }],
                    }],
                },
                dropdown:{
                    value:null,
                    value2:null,
                    options:["This is value 1","This is value 2","This is value 3","This is value 4"]
                },
                property: {
                    value: null
                }
            }
        },
        computed: {},
        watch: {},
        created() {

        },
        methods: {
        }
    }
</script>
